/* eslint-disable no-unused-vars */
import { QueryClient } from '@tanstack/react-query';

import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import _ from 'lodash';

import PropTypes from 'prop-types';

import { CircularProgress } from '@mui/material';

import { Layout, Footer, MetaData } from '../../../components/shared';

import { cmsService } from '../../../services/homii-services';

import { buildingDomain, roomTypesDomain } from '../../../domain';

import { useCitiesData } from '../../../domain/city/city.domain';

import { useBuildingsData } from '../../../domain/building/building.domain';

import RoomTypeDetails from '../../../components/room-type-details/room-type-details.component';

import localStorageService from '../../../services/storage-service/local-storage.service';

import { HOMII_KEYS } from '../../../../utils/constants';

const queryClient = new QueryClient();

const Room = (props) => {

    const { baseUrlApp, seoData, cmsData } = props;    

    const router = useRouter();

    const query = router.query;

    const { data: cities, isLoading: citiesLoading } = useCitiesData();  

    const { data: buildings, isLoading: buildingsLoading } = useBuildingsData();

    const startDate = _.get(query, 'startDate');

    const endDate = _.get(query, 'endDate');

    const roomTypeId = _.get(query, 'roomTypeId');    

    const seoTitle = _.get(seoData, 'seo_title');

    const seoMetaDesc = _.get(seoData, 'seo_meta_description');

    const [selectedRoomType, setSelectedRoomType] = useState(null);

    const [selectedBuilding, setSelectedBuilding] = useState(null);

    useEffect(() => {
        if (!roomTypeId || !buildings) {
            return; 
        }
        const asyncSearch = async () => {
            const fetchedRoomType = await roomTypesDomain.fetchRoomTypeById(buildings, roomTypeId);
            setSelectedRoomType(fetchedRoomType);
            const buildingId = _.get(fetchedRoomType, 'buildingId');
            const fetchedBuilding = await buildingDomain.fetchBuildingById(buildingId);
            setSelectedBuilding(fetchedBuilding);
            queryClient.setQueryData(['roomType', roomTypeId], fetchedRoomType);
        };
        asyncSearch();
        localStorageService.removeItem(HOMII_KEYS.QUOTE_PARAMS);
    },[roomTypeId, buildings]);

    const renderRoomTypeDetails = () => {        
        return <RoomTypeDetails 
                    selectedRoomType={selectedRoomType} 
                    buildings={buildings} 
                    cities={cities}
                    roomContentCMS={cmsData}
                    selectedBuilding={selectedBuilding}
                />;
    };

    const renderLoading = () => {
        return (
            <>
                <div className='booking-searching-container search-container-row'>
                    <CircularProgress />
                </div>
            </>            
        );
    };     

    return (
        <div>
            <Layout>

                <MetaData
                    title={seoTitle}
                    desc={seoMetaDesc}
                    canonical={`${baseUrlApp}/room/${_.get(query, 'roomTypeDescription')}/${_.get(
                        query,
                        'roomTypeId',
                    )}`}
                />

                {buildingsLoading || !selectedRoomType || !selectedBuilding || citiesLoading ? renderLoading() : renderRoomTypeDetails()}

                <Footer  />

            </Layout>
        </div>
    );
};

export const getServerSideProps = async () => {    
    const queryClient = new QueryClient();
   
    await queryClient.prefetchQuery({
        queryKey: ['buildings'],
        queryFn: buildingDomain.fetchAllBuildingsWithImages,
    });  

    const cmsData = await cmsService.RetrieveWordPressPage('room');
    const seoData = _.get(cmsData, 'acf');
    return {
        props: {
            seoData,
            cmsData
        }
    };
}

export default Room;

Room.propTypes = {
    query: PropTypes.object,
    baseUrlApp: PropTypes.string,
    seoData: PropTypes.object,
    peachRedirect: PropTypes.bool,
};
